var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cluster_asset_filter",
    width: "192.9%",
    height: "285.7%",
    x: "-46.4%",
    y: "-92.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd",
    filter: "url(#cluster_asset_filter)",
    transform: "matrix(-1 0 0 1 16 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.135 5.078a.645.645 0 0 1-.476-.206.576.576 0 0 1-.147-.476l.11-.715c.014.002.03.003.046.003h.725a.271.271 0 0 0 .269-.264.271.271 0 0 0-.269-.264H.702l.09-.594a.62.62 0 0 1 .624-.511h11.632c.348 0 .63.267.63.597v.542a.29.29 0 0 0-.137-.034h-.313a.283.283 0 0 0-.25.13.252.252 0 0 0 0 .27.283.283 0 0 0 .25.128h.313a.29.29 0 0 0 .137-.034v.831c0 .33-.282.597-.63.597H1.135z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M3.48 6a.483.483 0 0 0 .492-.473.483.483 0 0 0-.491-.474.483.483 0 0 0-.492.474c0 .261.22.474.492.474zm0 .633c-.633 0-1.147-.495-1.147-1.107 0-.61.514-1.105 1.148-1.105.633 0 1.147.495 1.147 1.106 0 .61-.514 1.106-1.147 1.106zm7-.632a.483.483 0 0 0 .492-.474.483.483 0 0 0-.491-.474.483.483 0 0 0-.492.474c0 .261.22.474.492.474zm0 .632c-.633 0-1.147-.495-1.147-1.107 0-.61.514-1.105 1.148-1.105.633 0 1.147.495 1.147 1.106 0 .61-.514 1.106-1.147 1.106zM.355 4.42l.813.01v.656H.354A.345.345 0 0 1 0 4.752c0-.089.037-.174.104-.236a.36.36 0 0 1 .25-.095zm13.3 0h-1.21l.355.657h.854A.338.338 0 0 0 14 4.749a.338.338 0 0 0-.347-.328zM4.764 0h1.828a.8.8 0 0 1 .558.223.716.716 0 0 1 .22.534L7.327 2.23c-.01.4-.356.718-.777.717H3.889a.787.787 0 0 1-.671-.364.703.703 0 0 1-.007-.734L4.086.376A.786.786 0 0 1 4.763 0zM4.23 1.3a.352.352 0 0 0 .01.363c.07.111.196.179.332.18h1.65a.38.38 0 0 0 .388-.37v-.368a.38.38 0 0 0-.389-.368H4.781a.392.392 0 0 0-.343.195l-.207.369z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset);
export default __webpack_public_path__ + "static/media/asset.6c27d556c8ddb3d3a387c7721dae4a5f.svg";
export { ForwardRef as ReactComponent };